import React, { useEffect } from "react";
import feather from "feather-icons";

const About = () => {
  useEffect(() => {
    setTimeout(() => feather.replace(), 200);
  }, []);

  const sections = [
    {
      icon: "book",
      color: "neonBlue",
      title: "Education",
      text: "NEXORA tokens grant access to premium educational content, courses, and certification programs focused on blockchain and digital skills.",
    },
    {
      icon: "music",
      color: "neonPink",
      title: "Culture",
      text: "Support emerging artists and creators through our decentralized platform where NEXORA holders vote on funding allocations.",
    },
    {
      icon: "heart",
      color: "neonBlue",
      title: "Health",
      text: "NEXORA powers health initiatives focused on mental wellbeing and physical health for young adults through partnerships with wellness providers.",
    },
    {
      icon: "users",
      color: "neonPurple",
      title: "Civic Life",
      text: "Our DAO gives NEXORA holders voting rights on social impact projects and advocacy campaigns that affect young people worldwide.",
    },
  ];

  return (
    <div className="text-white relative z-10 min-h-screen py-24 px-6 md:px-16 backdrop-blur-sm">
      {/* === HERO === */}
      <section className="text-center mb-20">
        <h1 className="text-5xl md:text-6xl font-extrabold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-neonPink via-neonPurple to-neonBlue animate-pulse">
          Our Mission
        </h1>
        <p className="text-xl max-w-3xl mx-auto text-gray-300">
          Empowering the next generation through blockchain technology in
          education, culture, health, and civic life — building a decentralized
          future for all.
        </p>
      </section>

      {/* === FEATURE GRID === */}
      <section className="grid md:grid-cols-2 gap-10 max-w-6xl mx-auto">
        {sections.map(({ icon, color, title, text }) => (
          <div
            key={title}
            className={`bg-gray-900 bg-opacity-70 backdrop-blur-lg rounded-2xl p-8 border border-${color}/40 hover:scale-105 transition-transform shadow-lg`}
          >
            <div className={`text-${color} mb-5`}>
              <i data-feather={icon} className="w-12 h-12"></i>
            </div>
            <h3
              className={`text-2xl font-bold text-${color} mb-3 tracking-wide`}
            >
              {title}
            </h3>
            <p className="text-gray-300 leading-relaxed">{text}</p>
          </div>
        ))}
      </section>

      {/* === CTA === */}
      <section className="text-center mt-20">
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-neonPink">
          Join the NEXORA Movement
        </h2>
        <p className="text-lg max-w-2xl mx-auto mb-8 text-gray-400">
          Whether you're a student, artist, activist, or entrepreneur — NEXORA
          empowers you to take part in a global decentralized movement that
          builds opportunities for all.
        </p>
        <a
          href="/projects"
          className="inline-block px-8 py-4 bg-gradient-to-r from-neonBlue to-neonPink rounded-lg font-bold hover:opacity-90 transition-all"
        >
          Explore Our Projects
        </a>
      </section>
    </div>
  );
};

export default About;
